var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCollapseButtton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.834473,
    width: 60,
    height: 60,
    rx: 30,
    fill: "black",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9375 25.4907C15.9375 24.2212 16.9629 23.147 18.2812 23.147V38.772C16.9629 38.772 15.9375 37.7466 15.9375 36.4282V25.4907ZM40.9375 18.4595C42.6465 18.4595 44.0625 19.8755 44.0625 21.5845V40.3345C44.0625 42.0923 42.6465 43.4595 40.9375 43.4595H28.4375C26.6797 43.4595 25.3125 42.0923 25.3125 40.3345V21.5845C25.3125 19.8755 26.6797 18.4595 28.4375 18.4595H40.9375ZM20.625 23.147C20.625 21.8774 21.6504 20.8032 22.9688 20.8032V41.1157C21.6504 41.1157 20.625 40.0903 20.625 38.772V23.147Z",
    fill: "url(#paint0_linear_1101_45550)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1101_45550",
    x1: 24.9673,
    y1: 41.3345,
    x2: 38.4055,
    y2: 22.7768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#622FF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44A0F8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseButtton);
export default __webpack_public_path__ + "static/media/collapseButtton.71bb80b786122cbe6828de413e1a8a2a.svg";
export { ForwardRef as ReactComponent };